import { render } from "./DoNotClose.vue?vue&type=template&id=61041f6a&scoped=true"
import script from "./DoNotClose.vue?vue&type=script&lang=js"
export * from "./DoNotClose.vue?vue&type=script&lang=js"

import "./DoNotClose.vue?vue&type=style&index=0&id=61041f6a&scoped=true&lang=css"

import exportComponent from "C:\\Apps\\AppBase\\app-base-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61041f6a"]])

export default __exports__